/**
 * 受注一覧 排出持込 一括本登録
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/self_emissions/definitive_registrations`

 const orders_accepts_self_emission_definitive_registration = {
  namespaced: true,
  actions: {
    /**
     * 排出持込 一括本登録
     * 受注一覧 運搬終了報告兼本登録一括登録よるコール
     * @param commit
     * @param params { Array<{ order_id: number, manifest_ids: Array<number> }> }
     * @return {Promise<unknown>}
     */
    update ({ commit }, { params }) {
      console.log(params)
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
 }

 export default orders_accepts_self_emission_definitive_registration
